module.exports = __webpack_public_path__ + "static/img/far1_c.cf9df18d.png";